import React, {useMemo} from 'react'
import RawAutocomplete from '@mui/material/Autocomplete'
import Input from './Input'
import {CircularProgress} from '@mui/material'
import {useUrlParams} from 'services/hooks'
import {isSameDocument} from 'utils'

const Autocomplete = ({
    label,
    isLoading,
    options,
    error,
    helperText,
    onChange,
    isFilter = true,
    InputProps,
    labelKey,
    multiple,
    isOptionEqualToValue,
    ...p
}) => {
    const {setUrlParam} = useUrlParams()
    const handleSelectChange = (value) => {
        if (value?.includes('') || !value?.length) {
            return setUrlParam(labelKey, '')
        }
        if (multiple) {
            value = value.map((item) => item?.key || item)
            setUrlParam(labelKey, value)
        } else {
            setUrlParam(labelKey, value?.key || value)
        }
    }

    const optionEquality = useMemo(() => {
        if (isOptionEqualToValue) return isOptionEqualToValue
        return (option, value) => isSameDocument(option, value)
    }, [isOptionEqualToValue])

    const {endAdornment: customEndAdornment, ...restInputProps} = InputProps || {}

    return (
        <RawAutocomplete
            loading={isLoading}
            options={options || []}
            getOptionLabel={(option) => option?.name || option}
            onChange={(e, newValue) => {
                onChange && onChange(e, newValue)
                isFilter && handleSelectChange(newValue)
            }}
            isOptionEqualToValue={optionEquality}
            renderInput={(params) => (
                <Input
                    {...params}
                    label={label}
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        ...params.InputProps,
                        ...restInputProps,
                        endAdornment: (
                            <>
                                {customEndAdornment}
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            multiple={multiple}
            {...p}
        />
    )
}

export default Autocomplete
